import { render, staticRenderFns } from "./disabilitycardManagerOrg.vue?vue&type=template&id=1e560ae0&scoped=true&"
import script from "./disabilitycardManagerOrg.vue?vue&type=script&lang=js&"
export * from "./disabilitycardManagerOrg.vue?vue&type=script&lang=js&"
import style0 from "./disabilitycardManagerOrg.vue?vue&type=style&index=0&id=1e560ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e560ae0",
  null
  
)

export default component.exports